import React from "react";
import { NavLink, useParams } from "react-router-dom";
import { ClipboardList, Clock, Landmark, StickyNote, User } from "lucide-react";
import { useWorkspace } from "./WorkspaceContext";

const linkClass = ({ isActive }: { isActive: boolean }) =>
  [
    "flex items-center justify-between h-9 px-3 rounded-full text-sm font-medium transition-colors",
    isActive
      ? "bg-[#E5EBFD] text-[#1453F5]"
      : "text-[#4A5466] hover:bg-[#EFF2F6]",
  ].join(" ");

function CountBadge({ count }: { count: number }) {
  if (count <= 0) {
    return null;
  }

  return (
    <span className="inline-flex min-w-5 items-center justify-center rounded-full bg-[#E5EBFD] px-1.5 py-0.5 text-[11px] font-semibold text-[#1453F5]">
      {count}
    </span>
  );
}

export function SectionNav() {
  const { applicationId } = useParams<{ applicationId: string }>();
  const { conditionCounts } = useWorkspace();

  if (!applicationId) {
    return null;
  }

  const base = `/pre-approval/${applicationId}`;

  const items = [
    {
      to: `${base}/conditions/customer`,
      label: "Customer Conditions",
      icon: User,
      count: conditionCounts.customer,
    },
    {
      to: `${base}/conditions/funding`,
      label: "Funding Conditions",
      icon: Landmark,
      count: conditionCounts.funding,
    },
    {
      to: `${base}/conditions/seller`,
      label: "Seller Conditions",
      icon: ClipboardList,
      count: conditionCounts.seller,
    },
    {
      to: `${base}/notes`,
      label: "Notes",
      icon: StickyNote,
      count: conditionCounts.notes,
    },
    {
      to: `${base}/history`,
      label: "Activity History",
      icon: Clock,
    },
  ];

  return (
    <nav className="w-[240px] shrink-0 bg-white border-r border-[#E4E7EC] py-6 px-4 flex flex-col gap-1">
      <div className="text-[10px] font-semibold text-[#9AA2B2] tracking-wide px-3 mb-2">
        WORKSPACE
      </div>
      {items.map((item) => (
        <NavLink key={item.to} to={item.to} className={linkClass}>
          <span className="flex items-center gap-2">
            <item.icon className="h-4 w-4" />
            {item.label}
          </span>
          {"count" in item && item.count !== undefined ? (
            <CountBadge count={item.count} />
          ) : null}
        </NavLink>
      ))}
    </nav>
  );
}
